import { render, staticRenderFns } from "./addcategory.vue?vue&type=template&id=c8ea2356"
import script from "./addcategory.vue?vue&type=script&lang=js"
export * from "./addcategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports